export const isEmptyObject = ( obj: any ): boolean => {
    let name;
    for ( name in obj ) {
        return false;
    }
    return true;
}